// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"165":"0d21da8c49f96f0150d8","888":"dee62d7df347400fa86d"}[chunkId] + ".css";
};